import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import { IS_BROWSER } from './constants'
import { bhEnv } from '@lib/env'

const client = axios.create({ baseURL: bhEnv.backendUrl })

let adminToken: Maybe<string> = null

if (IS_BROWSER && window) {
  // Get `token` parameter from query string
  const urlParams = new URLSearchParams(window.location.search)
  adminToken = urlParams.get('adminToken')
}

export default function medusaRequest(
  path: string,
  method: HTTPMethod = 'GET',
  payload?: any
) {
  const options: AxiosRequestConfig = {
    method,
    withCredentials: true,
    url: path,
    data: payload,
    // Don't throw error on 4xx or 5xx status codes
    validateStatus: (status: number) => true,
  }

  if (adminToken) {
    options.headers = {
      Authorization: `${adminToken}`,
    }
  }

  return client(options)
}

async function bhQuoteApiRequest<T>(
  path: string,
  method: HTTPMethod = 'GET',
  payload?: any
): Promise<AxiosResponse<T>> {
  const response = await medusaRequest(
    `${bhEnv.bhQuoteApiPath}${path}`,
    method,
    payload
  )

  return response as AxiosResponse<T>
}

async function bhStoreApiRequest<T>(
  path: string,
  method: HTTPMethod = 'GET',
  payload?: any
): Promise<AxiosResponse<T>> {
  const response = await medusaRequest(
    `${bhEnv.bhStoreApiPath}${path}`,
    method,
    payload
  )
  // if (response.statusText !== 'OK') {
  //   console.error(
  //     `Unable to fetch ${path}. Status: ${response.status} ${response.statusText}. Response data: ${response.data}`
  //   )
  //   throw new Error(
  //     `Error fetching ${path}: ${response.statusText}. Response data: ${response.data}`
  //   )
  // }

  return response as AxiosResponse<T>
}

export { bhQuoteApiRequest, bhStoreApiRequest }
